import { createRequest, RequestConfig } from 'app/common/api';

import { TTrip } from '../core/trips';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_trip_details',
};

export const getTripDetailsRequest = (trip: { id: TTrip['id'] }) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: {
      id: trip.id.toString(),
    },
  });
